import React from "react";
import './_index.scss';

export default class AutomationExchangeCard extends React.Component {
    static defaultProps = {
        data: {}
    };
    state = {
        logoLoaded: false,
        logoError: false
    }

    constructor(props) {
        super(props);
        if (props.data.html) {
            this.state = { ...this.state, data: JSON.parse(props.data.html) };
        } else {
            this.state = { ...this.state, data: props.data };
        }
    }

    render() {
        const item = this.state.data;
        if (!item) return null;

        const url = item.url ? (item.url.startsWith("http") ? item.url : window.location.origin + item.url) : undefined;

        const workflow = filedJoin((item.additionalTags || [])
            .filter(i => !i.startsWith('cx_'))
            .map(i => i.substring(0, 'Day 0'.length)));

        const products = filedJoin(item.products);
        const usecase = filedJoin(item.industries);
        const stageSteps = (item.categories || []).map(this.renderStageStep || []);

        return (<a href={url} className="tile" target={this.props.target} rel={this.props.target === '_blank' ? 'noopener noreferrer' : undefined}>
            <div className="tile-body">
                <div className="title">{item.name}</div>
                <div className="description">{item.description}</div>
                <ul className="filters">
                    <li className="filter-stage">
                        {stageSteps}
                    </li>
                    {this.renderFieldItem("usecase", usecase)}
                    {this.renderFieldItem("workflow", workflow)}
                    {this.renderDomainOrLanguage(item)}
                    {this.renderFieldItem("product", products)}
                </ul>
                {this.renderPartnerLogo(item.github_org_id)}
            </div>
        </a>)
    }

    handleLoad = () => {
        this.setState({ logoLoaded: true })
    }

    handleError = () => {
        this.setState({ logoError: true })
    }

    getPartnerLogoURL = (github_org_id) => {
        return github_org_id ? `${CONFIG.USER_GITHUB}${github_org_id}/g256.png` : ""
    }

    renderPartnerLogo(github_org_id) {
        const partnerLogo = github_org_id ? `${CONFIG.USER_GITHUB}${github_org_id}/g256.png` : ""
        if (!partnerLogo) return null;

        return (
            <div style={{ display: this.state.logoLoaded ? "" : "none" }} className="partner-logo-box">
                <span>By:</span><div className="partner-logo-container"><img onError={this.handleError} onLoad={this.handleLoad} src={partnerLogo}></img></div>
            </div>
        );
    }

    renderStageStep(step) {
        return (
            <span className='stage-step-item'>
                <span className="icon" data-type={step}></span>
                <span>{step}</span>
            </span>
        );
    }

    renderFieldItem(field, value) {
        if (!value) return null;

        return (
            <li className={"filter-" + field}>
                <span>{value}</span>
            </li>
        );
    }

    renderDomainOrLanguage(item) {
        const domain = filedJoin(item.technologyAreas);
        if (domain) {
            return (
                <li className="filter-domain">
                    <span>{domain}</span>
                </li>
            )
        }

        const language = filedJoin(item.programmingLanguages);
        if (language) {
            return (
                <li className="filter-language">
                    <span>{language}</span>
                </li>
            )
        }

        return null;
    }
}

function filedJoin(array) {
    return (array || []).join(", ");
}